<template>
  <div class="estatisticas">
    <div class="stat-icon">
      <v-icon :color="cor">{{ icon }}</v-icon>
    </div>
    <div class="stat-info">
      <span class="stat-title">{{ title }}</span>
      <span class="stat-value">{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Estatisticas',
  props: ['title', 'value', 'icon', 'cor'],
  computed: {
    style () {
      return 'color:' + (this.color || '#000')
    }
  }
}
</script>

<style scoped>
.estatisticas {
  flex: 1;
  display: flex;
  border-radius: 8px;
  margin-right: 20px;
  margin-bottom: 20px;
  background-color: #fff;
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  display: flex;
  align-items: center;
}

.stat-icon i {
  font-size: 5rem;
}

.stat-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.stat-title {
  font-size: 1.2rem;
}

.stat-value {
  font-size: 3rem;
}
</style>
